import { createSlice } from '@reduxjs/toolkit'
import { t } from 'i18next'

import { MokaiUser } from '../../../model/mokaiUser'

const initialState: MokaiUser = {
  userId: '',
  token: '',
  personId: 0,
  email: '',
  apiKey: '',
  displayName: t('core.role.guest'),
  firebaseUser: null,
  loadedBasicInformation: false,
}

const userSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    userSet: (state, action) => {
      state.userId = action.payload.userId
      state.firebaseUser = action.payload.firebaseUser
      state.apiKey = action.payload.apiKey
      state.personId = action.payload.personId
      state.loadedBasicInformation = action.payload.loadedBasicInformation
      state.token = action.payload.token
      state.email = action.payload.email
    },
    firebaseUserSet: (state, action) => {
      state.firebaseUser = action.payload
    },
    // claimsSet: (state, action) => {
    //   state.modules = [...action.payload]
    // },
    basicInformationLoaded: (state, action) => {
      state.loadedBasicInformation = action.payload
    },
    removedUser: (state) => {
      state = { ...initialState }
    },
  },
})

export const { userSet, firebaseUserSet, basicInformationLoaded, removedUser } =
  userSlice.actions

export default userSlice.reducer